export function authHeader() {
  let user = JSON.parse(localStorage.getItem('user'));

  if (user && user.token) {
    return { 'x-access-token': user.token, 'Content-Type': 'application/json' };
  } else {
    return { 'Content-Type': 'application/json' };
  }
}
